/**
 * OrgWhatsAppService — the organisation's WhatsApp number (Meta Cloud API).
 *
 * Numbers live on Cata's WhatsApp Business Account, so connecting one is a
 * Cata platform-admin action; org members only see the status.
 */
import { apiService } from './ApiService';
import { AxiosResponse } from 'axios';

export type WhatsAppStatusValue = 'NOT_CONNECTED' | 'CONNECTED' | 'DISCONNECTED';

export interface OrgWhatsAppStatus {
  organization_id?: number | null;
  status: WhatsAppStatusValue | string;
  phone_number?: string | null;
  display_name?: string | null;
  connected_at?: string | null;
  /** True for Cata platform admins — they may connect / disconnect numbers. */
  can_manage: boolean;
}

export interface ConnectWhatsAppRequest {
  phone_number_id: string;
  waba_id?: string;
  config?: Record<string, unknown>;
}

class OrgWhatsAppService {
  private static instance: OrgWhatsAppService;

  public static getInstance(): OrgWhatsAppService {
    if (!OrgWhatsAppService.instance) {
      OrgWhatsAppService.instance = new OrgWhatsAppService();
    }
    return OrgWhatsAppService.instance;
  }

  async getStatus(): Promise<AxiosResponse<OrgWhatsAppStatus>> {
    return apiService.get('/api/organization/channels/whatsapp/status');
  }

  /** Platform admin: connect a Meta phone_number_id to an organisation. */
  async connect(orgId: number, body: ConnectWhatsAppRequest): Promise<AxiosResponse<OrgWhatsAppStatus>> {
    return apiService.put(`/api/admin/organizations/${orgId}/whatsapp`, body);
  }

  /** Platform admin: disconnect the organisation's number. */
  async disconnect(orgId: number): Promise<AxiosResponse<{ status: string }>> {
    return apiService.delete(`/api/admin/organizations/${orgId}/whatsapp`);
  }
}

export const orgWhatsAppService = OrgWhatsAppService.getInstance();
